const defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
export const legacyGinIssueAssignRoute = {
	name: 'legacy-gin-issue-assign',
	path: `/secure/(\\w*)AssignIssue${defaultSuffix}.jspa`,
};
